/**
 * @file
 * Enable touch events functionality.
 */

(($, { behaviors }) => {
  /**
   * Attaches behaviors for enabling touch events.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches touch events functionality.
   */
  behaviors.enableTouchEvents = {
    attach(context) {
      $(".js-body", context).on("touchstart", () => {});
    }
  };
})(jQuery, Drupal);
